<mat-form-field
  [appearance]="appareance"
  class="w-full"
  [floatLabel]="!control.value ? 'always' : 'auto'"
>
  <mat-label>
    {{ label }}
  </mat-label>
  <input
    matInput
    readonly
    role="textbox"
    [matDatepicker]="picker"
    [formControl]="control"
    [attr.name]="name"
    [attr.aria-label]="label"
    [placeholder]="placeholder"
    [min]="minDate()"
    [max]="maxDate"
    autocomplete="on"
    [matDatepickerFilter]="dateFilter"
  />
  <mat-hint>giorno/mese/anno</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
</mat-form-field>
<mat-error siatErrorField [control]="control" [label]="label"></mat-error>
